/**
 * 重置message，防止重复点击重复弹出message弹框 
 */

import { Message ,MessageBox } from 'element-ui';



let messageInstance = null;
const message = (options) => {
    if(messageInstance) {
        messageInstance.close();
    }

    messageInstance = Message(options);
};

['error','success','info','warning'].forEach(type => {
    message[type] = options => {
        if(typeof options === 'string' || typeof options === 'number') {
            options = {
                message:options
            }
        }

        options.type = type;
        options.duration = 3000

        return message(options);
       
    }
})

message.closeAll = () => {
    Message.closeAll();
};

const e_confirm = ( param = {} ) => {

    //是否可通过点击遮罩关闭 MessageBox ,默认是
    if (!param.hasOwnProperty('freecolse')) {
        param.freecolse = true;
    }
    if (!param.hasOwnProperty('txt')) {
        param.txt = '确定要进行此操作吗？';
    }
    if (!param.hasOwnProperty('yes')) {
        param.yes = (data => {
            message.error('非法操作！')
        })

    }
    if (!param.hasOwnProperty('cancel')) {
        param.cancel = (data => {
            message.warning('已取消操作！')
        })

    }
    MessageBox.confirm(param.txt, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: param.freecolse,
        type: 'warning',

    }).then(() => {
        let funcc = eval(param.yes);
        new funcc;
    }).catch(() => {
        let funcc = eval(param.cancel);
        new funcc;
    });
}

// export const message = message;

export  {
    e_confirm,
    message
}